<button mat-raised-button class="green-action-button" [disabled]="isDisabled" (click)="btnClick.emit()">
  <mat-icon *ngIf="showTickIcon" class="tick-icon" aria-hidden="true">check</mat-icon>
  {{ buttonText | translate}}
</button>
